// components
import { IconComponent } from '@centria-ui-atoms/icon-component'

// bootstrap components
import { Row } from 'react-bootstrap'

// styles
import classes from '../styles.module.scss'

// types
import type { IconName } from '@centria-ui-atoms/icon-component'
import type { FC } from 'react'

type PageLoaderProps = {
  icon: IconName
}

export const PageLoader: FC<PageLoaderProps> = ({ icon }) => (
  <Row className={classes.container}>
    <IconComponent icon={icon} size='shareLogo' />
  </Row>
)
